export const DraggerIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} viewBox="0 0 40 40" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33333 6.25C7.18274 6.25 6.25 7.18274 6.25 8.33333V31.6667C6.25 32.8173 7.18274 33.75 8.33333 33.75H31.6667C32.8173 33.75 33.75 32.8173 33.75 31.6667V8.33333C33.75 7.18274 32.8173 6.25 31.6667 6.25H8.33333ZM3.75 8.33333C3.75 5.80203 5.80203 3.75 8.33333 3.75H31.6667C34.198 3.75 36.25 5.80203 36.25 8.33333V31.6667C36.25 34.198 34.198 36.25 31.6667 36.25H8.33333C5.80203 36.25 3.75 34.198 3.75 31.6667V8.33333Z"
        fill="#514B4D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1665 12.916C13.4761 12.916 12.9165 13.4757 12.9165 14.166C12.9165 14.8564 13.4761 15.416 14.1665 15.416C14.8569 15.416 15.4165 14.8564 15.4165 14.166C15.4165 13.4757 14.8569 12.916 14.1665 12.916ZM10.4165 14.166C10.4165 12.0949 12.0954 10.416 14.1665 10.416C16.2376 10.416 17.9165 12.0949 17.9165 14.166C17.9165 16.2371 16.2376 17.916 14.1665 17.916C12.0954 17.916 10.4165 16.2371 10.4165 14.166Z"
        fill="#514B4D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.7829 15.7821C26.2711 15.294 27.0626 15.294 27.5507 15.7821L35.884 24.1155C36.3722 24.6036 36.3722 25.3951 35.884 25.8832C35.3959 26.3714 34.6044 26.3714 34.1163 25.8832L26.6668 18.4338L9.21738 35.8832C8.72922 36.3714 7.93777 36.3714 7.44961 35.8832C6.96146 35.3951 6.96146 34.6036 7.44961 34.1155L25.7829 15.7821Z"
        fill="#514B4D"
      />
    </svg>
  );
};
